import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInboxmodule = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 37,
	viewBox: "0 0 48 37",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M47 13.6653L36.854 2.24866C36.367 1.47048 35.656 1 34.907 1H13.093C12.344 1 11.633 1.47048 11.146 2.24767L1 13.6663V22.8367H47V13.6653Z",
			stroke: "#61646B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.613 16.8128C33.613 15.2197 34.607 13.9046 35.84 13.9036H47V31.9059C47 34.0132 45.68 35.7402 44.05 35.7402H3.95C2.32 35.7402 1 34.0122 1 31.9059V13.9036H12.16C13.393 13.9036 14.387 15.2167 14.387 16.8098V16.8317C14.387 18.4248 15.392 19.7111 16.624 19.7111H31.376C32.608 19.7111 33.613 18.4128 33.613 16.8198V16.8128V16.8128Z",
			fill: "#FAFAFA",
			stroke: "#61646B"
		})
	]
});
const ForwardRef = forwardRef(SvgInboxmodule);
export default ForwardRef;
